const ProfileChart = () => import("./profileChart/ProfileChart.vue");
const timeAxis = () => import("@/components/common/timeAxis/Index.vue");
import * as clipWork from "@/components/tables/planClip/map.js";

import * as echarts from "echarts";
import * as mapWork from "./map.js";
export default {
  components: {
    ProfileChart,
    timeAxis,
  },
  data() {
    return {
      currentLayerId: "",
      open_profileChart_box: "",
      isFold: false,
      activeBtn: 0, // 被点击(激活)状态的按钮编号。
      marks: {
        0: "开始",
        // 15: "进度一",
        // 25: "进度二",
        // 35: "进度三",
        // 45: "进度四",
        // 55: "进度五",
        // 65: "进度六",
        75: "结束",
        // 120: "进度五",
        // 152: "进度五",
        // 182: "进度七",
        // 210: "进度六",
        // 244: "进度九",
        // 274: "进度七",
        // 305: "进度十一",
        // 366: "结束",
      },
      childId: window.sessionStorage.getItem("childId"),
    };
  },
  methods: {
    drawLine() {
      this.activeBtn = 1;
      //this.open_profileChart_box = "ProfileChart";
      mapWork.measureSection();
    },
    clean() {
      this.activeBtn = 2;
      mapWork.removeAll();
      this.open_profileChart_box = "";
      this.$refs.profileChart.clear();
    },

    profileAnalysisBox_close() {
      this.$emit("profileAnalysisBox_close");
    },

    verifyBtnIndex(index) {
      if (this.activeBtn === index) {
        return true;
      } else {
        return false;
      }
    },
    getMinZ(arr) {
      let minz = "dataMin";
      if (arr == null || arr.length === 0) {
        return minz;
      }
      minz = arr[0].alt;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].alt < minz) {
          minz = arr[i].alt;
        }
      }
      return minz;
    },

    setEchartsData(data) {
      if (data == null || data.arrPoint == null) {
        return;
      }
      const arrPoint = data.arrPoint;
      let inhtml = "";

      const option = {
        grid: {
          left: 10,
          right: 40,
          bottom: 10,
          top: 40,
          containLabel: true,
        },
        dataZoom: [
          {
            type: "inside",
            throttle: 50,
          },
        ],
        tooltip: {
          trigger: "axis",
          // position: function (point, params, dom, rect, size) {
          //    return [10, 20];
          // },
          formatter: (params) => {
            if (params.length === 0) {
              mapWork.hideTipMarker();
              return inhtml;
            }
            const hbgd = params[0].value; // 海拔高度
            const point = arrPoint[params[0].dataIndex]; // 所在经纬度
            const result = mapWork.calculation(params[0]);
            inhtml = `当前位置<br />
                          距起点：${result.len}<br />
                          海拔：<span style='color:${params[0].color};'>${result.hbgdStr}</span><br />
                          经度：${point.lng}<br />
                          纬度：${point.lat}`;
            mapWork.showTipMarker(point, hbgd, inhtml);
            return inhtml;
          },
        },
        xAxis: [
          {
            name: "行程",
            type: "category",
            nameTextStyle: { color: "rgb(255, 70, 131)" },
            boundaryGap: false,
            axisLine: {
              show: true,
            },
            axisLabel: {
              show: true,
              formatter: "{value} 米",
              color: "#fff",
            },
            data: data.arrLen,
          },
        ],
        yAxis: [
          {
            name: "高程",
            nameTextStyle: { color: "rgb(255, 70, 131)" },
            type: "value",
            min: this.getMinZ(arrPoint),
            axisLabel: {
              formatter: "{value} 米",
              color: "#fff",
            },
          },
        ],
        series: [
          {
            name: "高程值",
            type: "line",
            smooth: true,
            symbol: "none",
            sampling: "average",
            itemStyle: {
              normal: {
                color: "rgb(255, 70, 131)",
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "rgb(255, 158, 68)",
                  },
                  {
                    offset: 1,
                    color: "rgb(255, 70, 131)",
                  },
                ]),
              },
            },
            data: data.arrHB,
          },
        ],
      };
      this.$refs.profileChart.draw(option);
    },

    keyFrameFn(e) {
      console.log(e);
    },
    playpause(type) {},
    redo() {
      clipWork.dateNumFun(this.childId, 0);
    },
    watchValue(v) {
      clipWork.dateNumFun(this.childId, v);
    },
  },
  mounted() {
    let that = this;
    mapWork.addMeasure();
    mapWork.eventTarget.on("measureEnd", (event) => {
      that.open_profileChart_box = "ProfileChart";
      that.$nextTick(() => {
        that.setEchartsData(event);
      });
    });

    mapWork.eventTarget.on("measureClick", (event) => {
      if (event.value) {
        that.$nextTick(() => {
          that.setEchartsData(event.value);
        });
      }
    });
  },
  destroyed() {},
  watch: {},
};
